import { ExtraShipment } from "@cnx/common";
import api from "services/api";

class ExtraShipmentService {
  static getExtraShipmentsByStopId = async (stopId: string) => {
    const { data } = await api.get<ExtraShipment[]>("/extra-shipments", {
      params: {
        stopId,
      },
    });

    return data;
  };

  static getExtraShipmentsByTerminalId = async (terminalId: string) => {
    const { data } = await api.get<ExtraShipment[]>(
      `/terminals/${terminalId}/extra-shipments`
    );

    return data;
  };

  static getUnclearShipmentsCount = async ({
    terminalId,
  }: {
    terminalId: string | null;
  }) => {
    const { data } = await api.get<number>(
      "/terminals/unclear-shipments/count",
      {
        params: {
          terminalId,
        },
      }
    );

    return data;
  };
}

export default ExtraShipmentService;
